// A barrel cactus: a squat ribbed green dome with a little reddish flower on
// top. Ported 1:1 from age-of-mcp's classic cactus-barrel.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.CylinderGeometry(0.22, 0.26, 0.34, 9),
      color: "#4a8a4e", position: [0, 0.17, 0] },
    { geometry: new THREE.SphereGeometry(0.22, 9, 5, 0, Math.PI * 2, 0, Math.PI / 2),
      color: "#52964f", position: [0, 0.34, 0] },          // domed top
    { geometry: new THREE.IcosahedronGeometry(0.06, 0),
      color: "#d8643a", position: [0, 0.46, 0] },          // flower
  ];
}

export const cactusBarrel = defineModel({
  id: "cactus-barrel",
  batchId: "standard",
  name: "Cactus barrel",
  tags: ["scenery","cactus","barrel","low-poly","age-of-mcp","classic"],
  summary: "Low-poly cactus barrel.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.3,
  parts: () => partsFor(),
  animations: [],
});
